import { users } from './data'

export default {
    usersList: () => [200, {
        data: users,
        current: 1,
        perPage: 10,
        total: 2,
        lastPage: 1,
    }],
    usersCreate: () => [200, users],
    usersDetail: ({ url, baseURL, regex }) => {
        const path = url.replace(baseURL, '')
        const params = path.match(regex)
        const id = parseInt(params[1], 0)
        const user = users.find(({ id: userId }) => userId === id)

        if (!user) return [404]
        return [200, user]
    },
    usersEdit: () => [200, users[0]],
    usersDelete: () => [200, users[0]],
}
